import PT from 'prop-types';

const ColGroupsType = PT.arrayOf(PT.shape({
  name: PT.string.isRequired,
  columns: PT.arrayOf(PT.string).isRequired,
}));

export default ColGroupsType;



// WEBPACK FOOTER //
// ./src/lib/proptypes/colGroups.js